export const en = {
    cancel: 'Cancel',
    'no-creatives': 'No archived creatives',
    view: 'View'
};
